import { Helmet } from 'react-helmet';
import { Redirect, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
    Body,
    Header,
    BodyBegins,
    // parseHtmlString,
} from '@getanwar/html-parser';
import parseCSS, { globalStyles } from '@getanwar/style-generator';
import Frame, { FrameContextConsumer } from 'react-frame-component';
import React, { useMemo, useCallback, useEffect, useState } from 'react';

import { loadScripts } from '../util/siteScripts';
import { getPage } from '../redux/selectors/site';
import { fetchPage, fetchSite } from '../redux/actions';
import { getAuthUser, getSite } from '../redux/selectors';
import makeCounter from '../util/_makeCounter';
import initDynamicType from '../util/_initDynamicType';

function Preview(props) {
    const dispatch = useDispatch();
    const { siteId, pageId } = useParams();
    const [style, setStyle] = useState('');
    const user = useSelector(getAuthUser);
    const page = useSelector(getPage(pageId));
    const site = useSelector((state) => getSite(state, siteId));

    const userRoles = user?.roles?.concat(user?.membership?.promo);

    const siteData = useMemo(() => {
        return {
            page: page?.data ? JSON.parse(page.data) : null,
            global: site?.global ? JSON.parse(site.global) : null,
        };
    }, [page, site]);

    const generateStyle = useCallback(async () => {
        const { page, global } = siteData;
        let cssString = '';
        // TODO: Generate global styles
        cssString += global ? globalStyles(global) : '';
        // TODO: Refactor - use promise
        (function recursively(data) {
            if (!data) return;
            const { content, ...restOfData } = data;
            cssString += parseCSS(restOfData);
            if (Array.isArray(content)) {
                content.forEach(recursively);
            }
        })(page);

        return cssString;
    }, [siteData]);

    useEffect(() => {
        (async function () {
            const css = await generateStyle();
            setStyle(css);
        })();
    }, [generateStyle]);

    // Fetch site
    useEffect(() => {
        dispatch(fetchSite(siteId));
    }, [siteId, dispatch]);

    // fetch page
    useEffect(() => {
        pageId && dispatch(fetchPage(pageId));
    }, [pageId, dispatch]);
    // MARK: to see html code
    // useEffect(() => {
    //     (async function () {
    //         const { html } = await parseHtmlString({
    //             data: siteData,
    //             userRoles: [],
    //         });
    //         console.log('ANWARN', html);
    //     })();
    // }, [siteData]);

    if (!pageId && site?.pages) {
        const homepage = site.pages.find((page) => page.type === 'INDEX');
        return <Redirect to={`/preview/site/${siteId}/page/${homepage.id}`} />;
    }

    if (!siteData.page) return null;

    return (
        <>
            <Helmet>
                <title>Preview</title>
            </Helmet>

            <Frame
                style={{
                    border: 0,
                    width: '100vw',
                    height: '100vh',
                    borderStyle: 'none',
                    background: '#ffffff',
                    verticalAlign: 'middle',
                }}
                head={
                    <Header
                        data={siteData}
                        userRoles={userRoles}
                        disableIntegration={true}
                    >
                        <link
                            rel="stylesheet"
                            href="https://assets.dorik.com/shared/aos.css"
                        ></link>
                        <link rel="stylesheet" href="/css/main.1.css" />
                        {style ? <style>{style}</style> : null}
                    </Header>
                }
            >
                <FrameContextConsumer>
                    {({ document, window }) => {
                        window.onload = function () {
                            const script = document.createElement('script');
                            script.src =
                                'https://assets.dorik.com/shared/aos.js';
                            script.async = 'async';
                            script.defer = 'defer';

                            document.body.appendChild(script);
                            const timer = setInterval(() => {
                                if (window.AOS) {
                                    window.AOS.init();
                                    clearInterval(timer);
                                }
                            }, 500);

                            var scripts = loadScripts(document);
                            scripts.toggleNav();
                            scripts.stickyNav(window);
                        };
                        makeCounter(document);
                        initDynamicType(document);
                        return (
                            <>
                                <BodyBegins data={siteData} />
                                <Body
                                    data={siteData}
                                    interactionDisabled
                                    userRoles={userRoles}
                                />
                            </>
                        );
                    }}
                </FrameContextConsumer>
            </Frame>
        </>
    );
}

export default Preview;
